import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./motion-primitives";
import { SectionLabel } from "./About";
import { useLang, Rich } from "@/i18n/LanguageContext";

export const Approach = () => {
  const { c } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const orbY = useTransform(scrollYProgress, [0, 1], ["-8%", "14%"]);
  const orbScale = useTransform(scrollYProgress, [0, 1], [0.92, 1.08]);

  return (
    <section id="approach" ref={ref} data-testid="section-approach" className="relative grid min-h-[850px] overflow-hidden bg-deep text-paper md:grid-cols-[1fr_1.05fr]">
      <div className="relative h-[440px] overflow-hidden md:h-auto" style={{ background: "linear-gradient(135deg,#081a1d,#102a2c 50%,#071416)" }}>
        <motion.div
          style={{ y: orbY, scale: orbScale }}
          className="absolute left-[8%] top-[14%] h-[360px] w-[360px] md:h-[560px] md:w-[560px]"
        >
          <div className="relative h-full w-full animate-floaty" style={{ perspective: "1200px" }}>
            <motion.div
              className="absolute inset-[4%] rounded-full"
              style={{
                background: "radial-gradient(circle at 42% 36%, rgba(180,200,190,.30), rgba(40,80,74,.12) 52%, transparent 72%)",
              }}
              animate={{ opacity: [0.55, 0.95, 0.55], scale: [0.96, 1.04, 0.96] }}
              transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.img
              src="/images/osrelis-globe2.png?v=5"
              alt="OSRELIS"
              className="relative h-full w-full object-contain drop-shadow-[0_22px_70px_rgba(0,0,0,0.6)]"
              animate={{ rotate: 360 }}
              transition={{ duration: 22, repeat: Infinity, ease: "linear" }}
            />
          </div>
        </motion.div>
      </div>

      <div className="flex flex-col justify-center px-6 py-24 md:px-[7vw] md:py-32">
        <Reveal>
          <SectionLabel n="02" onDark>{c.approach.label}</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mb-9 font-serif text-[clamp(42px,4.6vw,76px)] font-normal leading-[1.02] tracking-[-0.02em]">
            <Rich text={c.approach.title} />
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="max-w-[550px] font-sans leading-[1.8] text-paper/65">{c.approach.body}</p>
        </Reveal>
        <Reveal delay={0.26}>
          <blockquote className="mt-16 border-t border-paper/15 pt-8 font-serif text-[clamp(26px,2.6vw,42px)] leading-[1.3] text-mist">
            <Rich text={c.approach.quote} />
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
};
